/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel, { ExitType } from 'cio/models/action';
import { PathType, WaitUntilBranchPathType } from 'cio/utils/visual-workflow-builder/branch-paths';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';
import { roundTimeframe, findRoundUnit } from 'cio/utils/round-timeframe-units';
import pluralize from 'cio/utils/pluralize';

interface BaseConditionalWaitActionConditionDescriptionArgs {
  action: ActionModel;
  type: WaitUntilBranchPathType;
  capitalize?: boolean;
}

interface ConditionDescriptionArgs extends BaseConditionalWaitActionConditionDescriptionArgs {
  type: PathType.ConditionWaitUntilPath;
  conditions: SerializedLegacyFilter[];
}

interface DelayEventDescriptionArgs extends BaseConditionalWaitActionConditionDescriptionArgs {
  type: PathType.DelayEventWaitUntilPath;
  delayEventAttr: string;
  delayEventAttrOffset: number;
}

interface MaximumWaitDescriptionArgs extends BaseConditionalWaitActionConditionDescriptionArgs {
  type: PathType.MaximumWaitUntilPath;
  exitType: ExitType;
  delay: number;
}

type ConditionalWaitActionConditionDescriptionArgs =
  | ConditionDescriptionArgs
  | DelayEventDescriptionArgs
  | MaximumWaitDescriptionArgs;

export default class ConditionalWaitActionConditionDescription extends Component<ConditionalWaitActionConditionDescriptionArgs> {
  PathType = PathType;

  // DelayEventWaitUntilPath
  get eventDelayDirection() {
    if (this.args.type !== PathType.DelayEventWaitUntilPath) {
      return;
    }

    return this.args.delayEventAttrOffset < 0 ? 'before' : 'after';
  }

  // DelayEventWaitUntilPath and MaximumWaitUntilPath
  get delayDuration() {
    if (this.args.type !== PathType.DelayEventWaitUntilPath && this.args.type !== PathType.MaximumWaitUntilPath) {
      return;
    }

    let delayValue = 0;

    switch (this.args.type) {
      case PathType.DelayEventWaitUntilPath:
        delayValue = Math.abs(this.args.delayEventAttrOffset);
        break;
      case PathType.MaximumWaitUntilPath:
        delayValue = this.args.delay;
        break;
    }

    let delay = roundTimeframe(delayValue);
    let { value, seconds } = findRoundUnit(delay);
    let count = delay / seconds;

    return `${count} ${pluralize(count, value)}`;
  }
}
